import { render, staticRenderFns } from "./BCXTagSelect.vue?vue&type=template&id=0387948a&scoped=true"
import script from "./BCXTagSelect.vue?vue&type=script&lang=ts"
export * from "./BCXTagSelect.vue?vue&type=script&lang=ts"
import style0 from "./BCXTagSelect.vue?vue&type=style&index=0&id=0387948a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387948a",
  null
  
)

export default component.exports